/* eslint-disable no-unused-vars */
import React from 'react';
/* eslint-enable no-unused-vars */

const filtersToQueryString = (filters) => {
  const str = [];
  const cleanFilters = Object.fromEntries(Object.entries(filters).filter(([_, v]) => v != null));
  for (const p in cleanFilters) {
    if (cleanFilters.hasOwnProperty(p)) {
      if (p === 'skills') {
        str.push(encodeURIComponent(p) + '=' + cleanFilters[p]);
      } else {
        str.push(encodeURIComponent(p) + '=' + encodeURIComponent(cleanFilters[p]));
      }
    }
  }
  return str.join('&');
};

export default filtersToQueryString;
